import { showErrorMessage } from 'actions/messages';
import { tasksApi } from 'services/api/tasks-api';
import { receiptsApi } from 'services/api/receipts-api';
import { workOrdersApi } from 'services/api/work-orders-api';
import {
  RECEIPTS_ADD,
  RECEIPTS_REMOVE,
  RECEIPTS_SET,
  RECEIPTS_SHOW_ADD_MODAL_SET,
  RECEIPTS_TO_EDIT_SET,
  RECEIPTS_UPDATE,
} from 'components/admin/work-orders/details/receipts/store/action-types';

function addReceipt(receipt) {
  return {
    type: RECEIPTS_ADD,
    payload: receipt,
  };
}

export function deleteReceipt(receiptId) {
  return (dispatch) => {
    return receiptsApi.deleteReceipt(receiptId).then((response) => {
      if (response.ok) {
        dispatch(removeTime(receiptId));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function setShowAddMaterialsModal(value) {
  return {
    type: RECEIPTS_SHOW_ADD_MODAL_SET,
    payload: value,
  };
}

export function createReceipt(taskId, values) {
  return (dispatch) => {
    return tasksApi.createReceipt(taskId, values).then((response) => {
      if (response.ok) {
        dispatch(setShowAddMaterialsModal(false));
        dispatch(addReceipt(response.receipt));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function editReceipt(
  receiptId,
  values,
  imageIdToDelete = null,
  documentIdToDelete = null
) {
  return (dispatch) => {
    return receiptsApi
      .editReceipt(receiptId, values, imageIdToDelete, documentIdToDelete)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowAddMaterialsModal(false));
          dispatch(updateReceipt(response.receipt));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function getReceipts(workOrderId) {
  return (dispatch) => {
    return workOrdersApi.getReceipts(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(setReceipts(response.receipts));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

function removeTime(receiptId) {
  return {
    type: RECEIPTS_REMOVE,
    payload: receiptId,
  };
}

function setReceipts(receipts) {
  return {
    type: RECEIPTS_SET,
    payload: receipts,
  };
}

export function setReceiptToEdit(receipt) {
  return {
    type: RECEIPTS_TO_EDIT_SET,
    payload: receipt,
  };
}

function updateReceipt(receipt) {
  return {
    type: RECEIPTS_UPDATE,
    payload: receipt,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/receipts/store/actions.js